import {Selection, root} from "./selection/index";

export default function(selector) {
  return typeof selector === "string"
      ? new Selection([[document.querySelector(selector)]], [document.documentElement])
      : new Selection([[selector]], root);
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-selection/src/select.js
// module id = 391
// module chunks = 0